import { getNewbuildingPromos } from './getNewbuildingPromos';
import { IState } from '../../store';

export const getHasNewbuildingPromos = (state: IState): boolean => {
  const promos = getNewbuildingPromos(state);

  return promos.length > 0;
};
